/*** IMPORTS FROM imports-loader ***/
var define = false;

export default {
  init: function () {
    const accordions = document.querySelectorAll('[data-accordion]');

    accordions.forEach((accordion) => {
      const accordionID = accordion.dataset.accordion;

      const openEls = document.querySelectorAll(`[data-accordion-open="${accordionID}"]`);
      openEls.forEach((openEl) => {
        openEl.addEventListener('click', (e) => {
          e.preventDefault();
          e.stopPropagation();
          this.open(accordion);
        });
      });

      const closeEls = document.querySelectorAll(`[data-accordion-close="${accordionID}"]`);
      closeEls.forEach((closeEl) => {
        closeEl.addEventListener('click', (e) => {
          e.preventDefault();
          e.stopPropagation();
          this.close(accordion);
        });
      });

      const toggleEls = document.querySelectorAll(`[data-accordion-toggle="${accordionID}"]`);
      toggleEls.forEach((toggleEl) => {
        toggleEl.addEventListener('click', (e) => {
          e.preventDefault();
          e.stopPropagation();
          if (accordion.classList.contains('open')) {
            this.close(accordion);
          } else {
            this.open(accordion);
          }
        });
      });

      // self-close: closes accordion if click outside of it.
      if (accordion.dataset.accordionSelfClose !== undefined) {
        document.body.addEventListener('click', (e) => {
          if (
            !e.target.closest(`[data-accordion-open="${accordionID}"]`) &&
            !e.target.closest(`[data-accordion-toggle="${accordionID}"]`) &&
            !e.target.closest(`[data-accordion="${accordionID}"]`)
          ) {
            this.close(accordion);
          }
        });
      }
    });
  },
  open: function(accordion) {
    accordion.classList.add('open');
    accordion.querySelectorAll('[data-close-icon]').forEach((el) => this.show(el));
    accordion.querySelectorAll('[data-open-icon]').forEach((el) => this.hide(el));
  },
  close: function(accordion) {
    accordion.classList.remove('open');
    accordion.querySelectorAll('[data-close-icon]').forEach((el) => this.hide(el));
    accordion.querySelectorAll('[data-open-icon]').forEach((el) => this.show(el));
  },
  show: function (el) {
    el.classList.remove('hiding');
  },
  hide: function (el) {
    el.classList.add('hiding');
  },
}

